import React, { useCallback, useEffect, useRef, useState } from 'react';

import WallComments from './wall_comments';
import ModalConfirm from '../modal/modal_confirm';
import ModalAlert from '../modal/modal_alert';
import ModalContentBase from '../modal/modal_content_base';
import WallsLikeUsers from './walls_like_users';

const Wall = ({
  wall,
  currentUser = null,
  isFormShow = false,
  isBodyShow = true,
  islikeShow = true,
}) => {
  const [isDisplay, setIsDisplay] = useState(true);
  const [likeUserIds, setLikeUserIds] = useState(
    wall && wall.walls_like_users
      ? wall.walls_like_users.map((like_user) => like_user.user_id)
      : []
  );
  const deleteCommentConfirmRef = useRef(null);
  const reportCommentConfirmRef = useRef(null);
  const reportCommentCompleteRef = useRef(null);
  const modalLikeUsersRef = useRef(null);

  useEffect(() => {
    if (wall && wall.walls_like_users) {
      const tmpLikeUserIds = wall.walls_like_users.map(
        (like_user) => like_user.user_id
      );
      setLikeUserIds(tmpLikeUserIds);
    }
  }, [wall, setLikeUserIds]);

  const deleteComment = useCallback(() => {
    $.ajax({
      url: '/api/walls/delete',
      type: 'POST',
      cache: false,
      headers: {
        'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content,
      },
      data: {
        wall_id: wall.id,
      },
    })
      .done(() => {
        setIsDisplay(false);
      })
      .fail(() => {});
  }, [setIsDisplay, wall]);

  const reportComment = () => {
    const formData = new FormData();
    formData.append('wall_id', wall.id);
    $.ajax({
      url: '/api/walls_violations',
      type: 'POST',
      cache: false,
      headers: {
        'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content,
      },
      data: formData,
      processData: false,
      contentType: false,
    })
      .done(() => {
        reportCommentCompleteRef.current.openModal();
      })
      .fail(() => {});
  };

  const handleLikeButton = useCallback(() => {
    const formData = new FormData();
    formData.append('wall_id', wall.id);
    $.ajax({
      url: '/api/walls/like',
      type: 'POST',
      cache: false,
      headers: {
        'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content,
      },
      data: formData,
      processData: false,
      contentType: false,
    })
      .done(() => {
        setLikeUserIds((v) => [...v, currentUser.id]);
      })
      .fail(() => {});
  }, [wall, setLikeUserIds]);

  const WallBody = useCallback(
    () => (
      <li key={wall.id}>
        <div className="row justify-content-around align-items-start pb-3">
          <div className="col-1 col-md-1 pl-0 mt-1">
            <img
              src={wall.company
                  ? (wall.companies_user ? wall.companies_user.avatar_thumb : '' ) 
                  : (wall.user ? wall.user.avatar_thumb : '')}
              className="event-member-icon"
            />
          </div>
          <div className="col">
            <div className="d-flex justify-content-between pl-1 mb-1" style={{ width: '94%' }}>
              <p className="text-fz-11px text-fw-bold text-fz-green mb-0">
                {wall.company ? (
                  <a
                    href={
                      wall.companies_user ? "/community/" + wall.company.id_to_param + "/member/" + wall.companies_user.member_id : ""
                    }
                    style={{ textDecoration: 'none' }}
                  >
                    @{wall.companies_user
                      ? wall.company.is_real_name_required 
                      ? wall.companies_user.view_full_name_disp : 
                        wall.companies_user.nickname
                    : "退会ユーザー"}
                  </a>
                ) : (
                  <a
                    href={
                      wall.user ? '/member/profile/' + wall.user.tunagate_id : ''
                    }
                    style={{ textDecoration: 'none' }}
                  >
                    @{wall.user ? wall.user.tunagate_id : '退会ユーザー'}
                  </a>
                )
                }
              </p>
              <div className="d-flex">
                <p className="text-fz-xs text-black-20 mb-0">
                  {wall.created_at_time_ago_format}
                </p>
                <div className="dropdown dropleft">
                  <img
                    style={{ padding: '0 2px 0 12px' }}
                    id="dropdownMenu"
                    height={15}
                    className="position-absolute"
                    data-toggle="dropdown"
                    src="/assets2019/img/icon_reader.svg"
                    alt=""
                  />
                  <div className="dropdown-menu" aria-labelledby="dropdownMenu">
                    {currentUser && currentUser.id == wall.user_id ? (
                      <button
                        onClick={() => deleteCommentConfirmRef.current.openModal()}
                        className="dropdown-item btn btn-light text-danger text-center"
                        type="button"
                      >
                        削除する
                      </button>
                    ) : (
                      <button
                        onClick={() => reportCommentConfirmRef.current.openModal()}
                        className="dropdown-item btn btn-light text-primary text-center"
                        type="button"
                      >
                        通報する
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <p
              className="text-fz-11px card border-0 bg-white mb-0 ml-2 p-3"
              dangerouslySetInnerHTML={{ __html: wall.body_disp }}
            />
            {/* {islikeShow && (
              <div className="d-flex">
                {!currentUser ? (
                  ''
                ) : !likeUserIds.includes(currentUser.id) ? (
                  <span
                    onClick={() => handleLikeButton()}
                    className="text-black-20 ml-2"
                  >
                    ♡
                  </span>
                ) : (
                  <p className="text-fz-xs text-black-20 mt-1 mb-0 ml-2">
                    いいね済
                  </p>
                )}
                {likeUserIds.length > 0 && (
                  <span
                    onClick={() => modalLikeUsersRef.current.openModal()}
                    data-wall_id={wall.id}
                    className="text-fz-xs text-black-20 mt-1 mb-0 ml-2"
                  >
                    {likeUserIds.length}件のいいね
                  </span>
                )}
              </div>
            )} */}
            <WallComments
              wallId={wall.id}
              currentUser={currentUser}
              isFormShow={isFormShow}
            />
          </div>
        </div>
      </li>
    ),
    [wall, currentUser, likeUserIds, WallComments, isFormShow, islikeShow]
  );

  return isDisplay ? (
    <div>
      {isBodyShow && <WallBody />}
      <ModalConfirm
        ref={deleteCommentConfirmRef}
        title="コメントの削除"
        content="コメントを削除しますか？"
        approveFunc={() => deleteComment()}
      />
      <ModalConfirm
        ref={reportCommentConfirmRef}
        title="コメントを通報"
        content="コメントを通報しますか？"
        approveFunc={() => reportComment()}
      />
      <ModalAlert
        ref={reportCommentCompleteRef}
        title="完了"
        content="コメントの通報が完了しました。"
      />
      {islikeShow && (
        <ModalContentBase
          ref={modalLikeUsersRef}
          previewContent={<div />}
          modalContent={<WallsLikeUsers wallId={wall.id} />}
        />
      )}
    </div>
  ) : (
    ''
  );
};

export default Wall;
